<template>
  <div>
    <transition name="toast">
      <div class="toast"
        v-show="showFlag">
        <div class="loading-container">
          <div class="toast-loader"
            v-if="pass1.icon=='loading'">
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
            <div class="spoke"></div>
          </div>
          <div class="success"
            v-else-if="pass1.icon=='success'">
            <div class="success-pic"></div>
          </div>
          <div class="fail"
            v-else-if="pass1.icon=='fail'">
            <div class="before"></div>
            <div class="after"></div>
          </div>
          <div class="toast-title"
            v-text="pass1.title"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    pass1: {
      type: Object,
      default: () => {
        return {
          show: true,
          title: '加载中...',
          icon: 'loading',
          duration: 2000
        }
      }
    }
  },
  data: function () {
    return {
      showFlag: false
      // toastData: {
      //   show: true,
      //   title: "加载中...",
      //   icon: "loading",
      //   duration: 9999999999999
      // }
    }
  },
  mounted: function () {
    var vm = this
    // 把父组件的变量的指针给到子组件,从此父组件更新这一变量,子组件也同时更新
    // vm.toastData = vm.pass1;
  },
  methods: {
    show (payload) {
      if (payload) {
        this.pass1.title = payload.title
        this.pass1.icon = payload.icon
        this.pass1.duration = payload.duration
      }
      // console.log(this.pass1.title)
      this.showFlag = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.hide()
      }, this.pass1.duration)
    },
    hide () {
      this.showFlag = false
    },
    showToast () {
      var vm = this
      // 指针
      for (var key in vm.pass1) {
        vm.toastData[key] = vm.pass1[key]
      }
      vm.toastData.show = true
      // console.log("showtoast", vm.toastData.show);
      // showToast不传duration,默认动画效果无穷大
      vm.toastData.duration = vm.pass1['duration'] || 0

      if (vm.toastData.duration) {
        setTimeout(function () {
          vm.toastData.show = false
        }, vm.toastData.duration)
      }
      // console.log("showtoast", vm.pass1.show);
    }
  }
}
</script>

<style lang="less" scoped>
// toast弹窗
.toast {
  position: fixed;
  width: 100%;
  top: -1rem/200;
  bottom: -1rem/200;
  background-color: transparent;
  z-index: 99999;
  .loading-container {
    background: rgba(0, 0, 0, 0.7);
    width: 250/200rem;
    min-height: 250/200rem;
    position: fixed;
    top: 50%;
    margin-top: -250/200rem;
    left: 50%;
    margin-left: -250/400rem;
    border-radius: 9/200rem;
    .toast-title {
      font-size: 30/200rem;
      color: #fff;
      padding-top: 40/200rem;
      text-align: center;
      width: 200rem/200;
      line-height: 50/200rem;
      margin: 0 auto;
      padding-bottom: 20/200rem;
    }
    .toast-loader {
      margin: 0 auto;
      height: 125/200rem;
      position: relative;
    }
    .spoke {
      position: absolute;
      top: 100%;
      margin-top: -15/200rem;
      left: 50%;
      margin-left: -15/200rem;
      transform-origin: 50% -100%;
      background: #fff;
      width: 5/200rem;
      height: 15/200rem;
      animation: spoke 1.2s infinite;
      border-radius: 5/200rem;
    }
    .spoke:nth-of-type(0n + 1) {
      transform: translateX(100%) rotate(-90deg);
      animation-delay: 0.3s;
    }
    .spoke:nth-of-type(0n + 2) {
      transform: translateX(100%) rotate(-60deg);
      animation-delay: 0.4s;
    }
    .spoke:nth-of-type(0n + 3) {
      transform: translateX(100%) rotate(-30deg);
      animation-delay: 0.5s;
    }
    .spoke:nth-of-type(0n + 4) {
      transform: translateX(100%) rotate(0deg);
      animation-delay: 0.6s;
    }
    .spoke:nth-of-type(0n + 5) {
      transform: translateX(100%) rotate(30deg);
      animation-delay: 0.7s;
    }
    .spoke:nth-of-type(0n + 6) {
      transform: translateX(100%) rotate(60deg);
      animation-delay: 0.8s;
    }
    .spoke:nth-of-type(0n + 7) {
      transform: translateX(100%) rotate(90deg);
      animation-delay: 0.9s;
    }
    .spoke:nth-of-type(0n + 8) {
      transform: translateX(100%) rotate(120deg);
      animation-delay: 1s;
    }
    .spoke:nth-of-type(0n + 9) {
      transform: translateX(100%) rotate(150deg);
      animation-delay: 1.1s;
    }
    .spoke:nth-of-type(0n + 10) {
      transform: translateX(100%) rotate(180deg);
      animation-delay: 0s;
    }
    .spoke:nth-of-type(0n + 11) {
      transform: translateX(100%) rotate(210deg);
      animation-delay: 0.1s;
    }
    .spoke:nth-of-type(0n + 12) {
      transform: translateX(100%) rotate(240deg);
      animation-delay: 0.2s;
    }
    // success图标
    .success {
      width: 125rem/200;
      min-height: 125rem/200;
      margin: 0 auto;
      .success-pic {
        width: 125rem/200;
        height: 125rem/200;
        background-image: url("../assets/images/success.png");
        background-position: center 10rem/200;
        background-repeat: no-repeat;
        background-size: 150rem/200 150rem/200;
      }
    }
    // fail图标
    .fail {
      width: 125rem/200;
      min-height: 125rem/200;
      margin: 0 auto;
      position: relative;
      .before {
        position: absolute;
        left: 50%;
        top: 40rem/200;
        background-color: #fff;
        height: 100rem/200;
        width: 12rem/200;
        border-radius: 12rem/200;
        transform: rotate(45deg);
        margin-left: -12rem/400;
      }
      .after {
        position: absolute;
        left: 50%;
        top: 40rem/200;
        background-color: #fff;
        height: 100rem/200;
        width: 12rem/200;
        border-radius: 12rem/200;
        transform: rotate(-45deg);
        margin-left: -12rem/400;
      }
    }
  }
}

@keyframes spoke {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}

// 弹窗淡入淡出动效
/*@supports如果浏览器支持transform: scale3d(0, 0, 1)和animation-timing-function: cubic-bezier(0.6,0,0.4,1)则执行这段代码*/
/*有 or and not等操作符 */
@supports (transform: scale3d(0, 0, 1)) and
  (animation-timing-function: cubic-bezier(0.6, 0, 0.4, 1)) {
  @keyframes bounce-in {
    0% {
      transform: scale(1.1);
      opacity: 0;
    }
    50% {
      transform: scale(1.05);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes bounce-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  // 确认弹窗动画
  .modal-enter-active {
    animation: bounce-in 0.2s;
  }
  .modal-leave-active {
    animation: bounce-out 0.2s;
  }

  // toast弹窗淡出动画
  .toast-leave-active {
    animation: bounce-out 0.5s;
  }

  // 删除列表过渡动画
  .list-complete-item {
    transition: all 5s;
  }
  .notShowAnimate {
    transition: all 0s;
  }
  .list-complete-enter {
    transform: translateY(0rem/200);
  }
  .list-complete-enter-to {
    transform: translateY(0rem/200);
  }
  .list-complete-enter-active {
    transform: translateY(0rem/200);
  }
  .list-complete-leave-to {
    opacity: 0;
    transform: translateY(-374rem/200);
  }
  .list-complete-leave-active {
    position: absolute;
    z-index: -1;
  }
}
</style>
